import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { mainStyles } from './dashboardStyles';

import StatCard from './Components/StatCard';
import Graph from './Components/Graph/Graph';

function Dashboard() {
  const classes = mainStyles();
  const [graphType, setGraphType] = useState("users");

  return (
    <Box className={classes.box}>
      <StatCard setGraphType={setGraphType} selectedType={graphType} />
      <Graph type={graphType} />
    </Box>
  );
}

export default Dashboard;
